<wiz-vgroup verticalAlign="start" horizontalAlign="start" width="100%" height="100%" gap="3">
  
  <wiz-vgroup  width="100%" class="section-container">
    <wiz-label wizLabel="$.vision.$" class="smallTitleLabel"></wiz-label>
      <wiz-dropdown [visible]="moreThanOnce"
        #ddVision
        width="100%"
        wizPanelWidth="250px"
        [wizDataProvider]="visionSource"
        [wizShowLabel]="false"
        [wizMandatory]="true"
        [wizLabelField]="'trsLabel'"
        class="roundedDropDown"
      ></wiz-dropdown>
  </wiz-vgroup>
  
  

  <wiz-vgroup [visible]="webMode" class="section-container" width="100%" height="100%">
     <wiz-label wizLabel="$.navigation.display.views.$" class="smallTitleLabel"></wiz-label>
     <wiz-hgroup width="100%" height="100%" >
      <wiz-tab-bar #tabBar width="100%" height="100%" 
        [showNavigation]="false"
        [orientation]="'column'"
        [wizButtonList]="tabs"></wiz-tab-bar>
     </wiz-hgroup>
      
  </wiz-vgroup>
 
  
  <wiz-hgroup *ngIf="webMode" class="section-container" width="100%" (click)="showTabView()" style="padding-top: 10px;">
    <wiz-label wizLabel="$.navigation.manage.views.$" width="100%" class="smallTitleLabel"></wiz-label>
    <wiz-icon class="image-back-orange smallMe" [wizTooltip]="'$.navigation.manage.views.$'" tooltipPlacement="right">add</wiz-icon>
  </wiz-hgroup>

</wiz-vgroup>
